module.exports = __webpack_public_path__ + "img/no-expense.088cfeca.png";